const strikethroughIcon = `
<svg fill="#444" width="20px" height="20px" viewBox="0 0 24 24" id="strikethrough-square" data-name="Flat Color" xmlns="http://www.w3.org/2000/svg" class="icon flat-color" stroke="#444">
  <g id="SVGRepo_bgCarrier" class="ql-stroke" stroke-width="0"></g>
  <g id="SVGRepo_tracerCarrier" class="ql-stroke " stroke-linecap="round" stroke-linejoin="round"></g>
  <g id="SVGRepo_iconCarrier" class="ql-stroke ">
    <rect id="primary" x="2" y="2" width="20" height="20" rx="2" style="fill: #4444;" class="ql-stroke"></rect>
    <path id="secondary" class="ql-stroke" d="M17,11H13V8h2a1,1,0,0,0,2,0V7a1,1,0,0,0-1-1H8A1,1,0,0,0,7,7V8A1,1,0,0,0,9,8h2v3H7a1,1,0,0,0,0,2h4v3a1,1,0,0,0,0,2h2a1,1,0,0,0,0-2V13h4a1,1,0,0,0,0-2Z" style="fill: #4444;"></path>
  </g>
</svg>
`;

export default strikethroughIcon;
